<template>
  <div class="home-menu-section">
      <div class="container home-menu">
          <router-link to="/account" class="home-menu-list">
              <div class="home-menu-icon">
                  <img src="@/assets/img/icon/akun.png" alt="akun">
              </div>
              <div class="home-menu-text text-color-grey mt-3">
                  Akun Saya
              </div>
          </router-link>
          <router-link to="/benefit" class="home-menu-list">
              <div class="home-menu-icon">
                  <img src="@/assets/img/icon/benefit.png" alt="benefit">
              </div>
              <div class="home-menu-text text-color-grey mt-3">
                  Benefit Saya
              </div>
          </router-link>
          <router-link to="/rekanan" class="home-menu-list">
              <div class="home-menu-icon">
                  <img src="@/assets/img/icon/rekanan.png" alt="rekanan">
              </div>
              <div class="home-menu-text text-color-grey mt-3">
                  Provider
              </div>
          </router-link>
      </div>

    <b-modal id="wa-unavailable" ref="waUnavailable"
             hide-header hide-footer centered modal-class="modal-fix-width">
      <div class="text-center m-4">
        <h5 class="text-color-blue mb-3">Pemberitahuan Gangguan Layanan</h5>

        <p class="text-description">
          Kami informasikan bahwa layanan WhatsApp<br>
          saat ini sedang mengalami kendala.
        </p>

        <p class="text-description">
          Mohon maaf atas ketidaknyamanan yang terjadi.
        </p>

        <p class="text-description">
          Untuk sementara, Anda dapat menghubungi kami melalui:<br>
          <strong class="text-color-blue">Email CS: CS@Salvus.co.id</strong>
        </p>

        <p class="text-description">
          Terima kasih atas pengertian Anda.
        </p>
      </div>
      <b-button class="color-blue mt-3" block @click="$bvModal.hide('wa-unavailable')">TUTUP</b-button>
    </b-modal>
  </div>


</template>

<script>
export default {
  data() {
    return {
      isWhatsappAvailable: true
    }
  },

  async created() {
    try {
      let response = await this.$apiController('get', `/service/whatsapp`);

      if (response && response.is_ok === false) {
        this.isWhatsappAvailable = false;
        this.$refs.waUnavailable.show();
      } else {
        this.isWhatsappAvailable = true;
      }

    } catch (err) {
      this.$refs.waUnavailable.show();
      this.isWhatsappAvailable = false;
      console.log("Whatsapp Service Error:", err);
    }
  }
}

</script>

<style>
.modal-fix-width .modal-dialog {
  max-width: 400px !important;
  width: 100% !important;

  margin-left: auto !important;
  margin-right: auto !important;

  position: relative !important;
  left: auto !important;
}

@media (max-width: 450px) {
  .modal-fix-width .modal-dialog {
    max-width: 90% !important;
  }
}
</style>